
import React ,{useEffect , useState} from 'react'
import {Link} from "react-router-dom"

// import swal from 'sweetalert';



import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";



const Cate = (props) =>{
  
      const [MainCatogories , setMainCatogories] = useState([])
const [data , setData] = useState([


  

  {
        "_id": "6797ca68fcb322000cf4c98f",
        "MainCategories": "Indoor Plant",
        "photo": "https://ik.imagekit.io/ynxypworn/io%20(2)%20Indoor%20plants.png?updatedAt=1752058756335",
        "sort": 1,
        "__v": 0
    },
    {
        "_id": "6798cc16071fed000c46cfe3",
        "MainCategories": "Outdoor Plant",
        "photo": "https://ik.imagekit.io/ynxypworn/io%20(6)%20outdoor%20plants.png?updatedAt=1752058842141",
        "sort": 1,
        "__v": 0
    },
     {
        "_id": "679b43081c6b24000c26d3a3",
        "MainCategories": "Plant bundles",
        "photo": "https://ik.imagekit.io/ynxypworn/io%20(1)%20Plant%20bundles.png?updatedAt=1752058726741",
        "sort": 1,
        "__v": 0
    },
    {
        "_id": "679b5a7faeab27000cdc8195",
        "MainCategories": " Flower Bouquets",
        "photo": "https://ik.imagekit.io/ynxypworn/io%20(5)%20Flower%20Bouquets.png?updatedAt=1752058810775",
        "sort": 1,
        "__v": 0
    },
    {
        "_id": "6799e004bcf8b2000c638f78",
        "MainCategories": "Exotic plants",
        "photo": "https://ik.imagekit.io/ynxypworn/io%20(7)%20Exotic%20plants.png?updatedAt=1752058864372",
        "sort": 1,
        "__v": 0
    },
    {
        "_id": "679b3255b2f331000c953c94",
        "MainCategories": "Artificial plants",
        "photo": "https://ik.imagekit.io/ynxypworn/io%20(4)%20Artificial%20plants.png?updatedAt=1752058792035",
        "sort": 1,
        "__v": 0
    },
    {
        "_id": "679b326ab2f331000c953c95",
        "MainCategories": "Pots and planters",
        "photo": "https://ik.imagekit.io/ynxypworn/io%20(3)%20pots%20and%20planters.png?updatedAt=1752058775430",
        "sort": 1,
        "__v": 0
    },
   
    {
        "_id": "679c5b44033385000c3a801d",
        "MainCategories": "Garden Accessories",
        "photo": "https://ik.imagekit.io/ynxypworn/io%20(15)%20Garden%20accessories.png?updatedAt=1752060295555",
        "sort": 1,
        "__v": 0
    }


])


      // useEffect(() =>{


      //   fetch("https://plant-heaven-dubai-main-backs.vercel.app/MainCatogories",{
      //       method: "GET",
      //        headers :  {
      //        "Content-Type" : "application/json" , 
      //    } ,
      //   })
      //   .then(res2=>res2.json())
      //   .then(res3=>{
      //       console.log(res3);
      //       // setMainCatogories(res3)
            

      //       // let dat = []
      //       // res3.map((res55,c)=>{
      //       //     dat.push(res55)
      //       // })
      //       // // console.log(SubClassCategories,asse)
      //       // console.log(dat)
      //       // let data = dat.sort((a, b) => {
      //       //     return a.sort - b.sort;
      //       // });
      //       setMainCatogories(res3)
            
      //   })

// },[])


return (

<div style={{display:"flex",background :"#F9F9F9",margin:"auto",flexFlow: "wrap",justifyContent: "center"}}>












{  
data.map((res,i)=>{
  
      

        // if(i+1 == 1 || i+1 == 4 || i+1 == 5 || i+1 == 8 || i+1 ==9){
        //   if(res.MainCategories ===  "Bridals"){
            return (
                            
            <div className="col-md-4 col-lg-4 col-sm-12 category position-relative" style={{margin:"0px 0px",border:"1px solid white", background:"white",borderRadius:"10px",padding  :"10px 7px"}}>
                                                        <div>
                                                              <Link style={{  display: "flex",
                justifyContent: "center",
                alignItems: "flex-end",  overflow: "hidden"   ,height:"400px"           }} to={"/categories/"+res.MainCategories+"/all-products"} >
                                                            <img src={res.photo} className="sdfsfkkj6" width={"100%"} height={160} style={{width :"100%",height:"400px",margin: "auto"}} alt={res.MainCategories}/>
                                                           {/* <span className="category-title font-weight-normal sdfsfkkj11" ><b className='sdfsfkkj31' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                                        fontWeight: "400"}}>{res.MainCategories}        </b> </span> */}
                                                           <span className="category-title font-weight-normal sdfsfkkj111" ><b className='sdfsfkkj311' style={{ borderRadius : "5px",color : "black",maxWidth:"100px",height:"70px",fontSize: "1em",lineHeight: 1.1,
                                        fontWeight: "400"}}>   >       </b> </span>
                                                          </Link>
                                                        </div>
                                                        
                                                      </div>


           
              )
     
                          })
               }
</div>
            
                        
          

    )
}

export default Cate